import React from 'react';
import { Table, Input, Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { F1046 } from '../../../services/companyApi';

interface Props {
  isEditing: boolean;
  orderCustomers: F1046[];
  setOrderCustomers: (v: F1046[]) => void;
  companyCode: string;
}

const Tab5OrderCustomers: React.FC<Props> = React.memo(({ isEditing, orderCustomers, setOrderCustomers, companyCode }) => {
  const updateRow = (idx: number, field: keyof F1046, value: string | number) => {
    const next = [...orderCustomers];
    next[idx] = { ...next[idx], [field]: value };
    setOrderCustomers(next);
  };

  const addRow = () => {
    const maxNo = orderCustomers.reduce((m, oc) => Math.max(m, oc.f1046_no), 0);
    setOrderCustomers([...orderCustomers, {
      f1046_01: companyCode, f1046_02: '', f1046_no: maxNo + 1,
    }]);
  };

  const deleteRow = (idx: number) => {
    setOrderCustomers(orderCustomers.filter((_, i) => i !== idx));
  };

  const columns = [
    { title: '項次', dataIndex: 'f1046_no', width: 60,
      render: (_: number, __: F1046, i: number) => i + 1 },
    { title: '公司代號', dataIndex: 'f1046_02', ellipsis: true,
      render: (v: string, _: F1046, i: number) => isEditing
        ? <Input size="small" value={v} onChange={e => updateRow(i, 'f1046_02', e.target.value)} />
        : v },
    ...(isEditing ? [{
      title: '', width: 40,
      render: (_: unknown, __: F1046, i: number) => (
        <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={() => deleteRow(i)} />
      ),
    }] : []),
  ];

  return (
    <div>
      {isEditing && (
        <Button size="small" icon={<PlusOutlined />} onClick={addRow} className="mb-2">新增下單客戶</Button>
      )}
      <Table dataSource={orderCustomers} columns={columns} rowKey={(_, i) => String(i)}
        size="small" pagination={false} scroll={{ y: 240 }} />
    </div>
  );
});

export default Tab5OrderCustomers;
